module.exports = __webpack_public_path__ + "static/integration_img_mobile-f184b648894cffb3272f967914c8cce6.jpg";